import { jsxs as t, jsx as s } from "react/jsx-runtime";
import m from "react";
import { FloatLabel as p } from "../FloatLabel/FloatLabel.js";
import { Icon as u } from "../../../Icon/Icon.js";
const h = "InputWithError-module_error__H6Fpx",
  E = "InputWithError-module_icon__ywFZY",
  r = {
    error: h,
    icon: E
  },
  _ = _ref => {
    let {
      name: e,
      label: c,
      id: i,
      children: n,
      forceLabelRenderAsFocused: a = !1,
      errorMessageComponent: o,
      validationState: l = void 0
    } = _ref;
    const d = l == "error";
    return /* @__PURE__ */t("div", {
      className: r.inputWithError,
      "data-controlled-input": !0,
      children: [/* @__PURE__ */s(p, {
        label: c,
        id: i,
        forceFocus: a,
        validationState: l,
        children: m.cloneElement(n, {
          id: i,
          name: e,
          validationState: l,
          "aria-invalid": d
        })
      }), d && o && /* @__PURE__ */t("div", {
        className: r.error,
        children: [/* @__PURE__ */s(u, {
          name: "alert",
          padding: !1,
          className: r.icon
        }), o]
      })]
    });
  },
  I = _ref2 => {
    let {
      name: e,
      id: c,
      children: i,
      errorMessageComponent: n,
      validationState: a = void 0
    } = _ref2;
    const o = a == "error";
    return /* @__PURE__ */t("div", {
      className: r.inputWithError,
      "data-controlled-input": !0,
      children: [m.cloneElement(i, {
        id: c,
        name: e,
        "aria-invalid": o
      }), o && n && /* @__PURE__ */t("div", {
        className: r.error,
        children: [/* @__PURE__ */s(u, {
          name: "alert",
          padding: !1,
          className: r.icon
        }), n]
      })]
    });
  };
export { I as BasicInputWithError, _ as InputWithError };